import { STORE_CUSTOM_FIELDS_RAW_STATE_KEY } from '~~/constants/stateKeys';
import type { RawCustomFields } from '~~/types/commercetools';

export const useStoreCustomFields = () => {

  const customFieldsRaw = useState<RawCustomFields>(STORE_CUSTOM_FIELDS_RAW_STATE_KEY, () => []);

  const setCustomFieldsRaw = (value: RawCustomFields) => {

    customFieldsRaw.value = value ?? [];

  };

  return { customFieldsRaw, setCustomFieldsRaw };

};
